import './css/styles.scss';

// import Swiper JS and its modules
import Swiper from 'swiper';
import { Pagination, Mousewheel, FreeMode, Navigation, } from 'swiper/modules';
//import SwiperAnimation from '@cycjimmy/swiper-animation';
//import 'animate.css';


//const $ = window.jQuery;

//import Swiper, { Mousewheel, FreeMode, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

const initPostSwiper = function () {
    const $postSwiper = document.querySelector('.postSwiper');
    if (!$postSwiper) return;

    const $slides = $postSwiper.querySelectorAll('.swiper-slide');
    if (!$slides.length) return;

    // count slides
    const $countSlides = $slides.length;
    console.log($countSlides);

    //const swiperAnimation = new SwiperAnimation();

    Swiper.use([Mousewheel, FreeMode, Navigation, Pagination]);

    const swiper = new Swiper('.postSwiper', {
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: false,
		 centeredSlides: true,
        loop: true,
        loopFillGroupWithBlank: true,
   /*      infinit: true, */
        navigation: {
            nextEl: ".postSwiper .swiper-button-next",
            prevEl: ".postSwiper .swiper-button-prev",
        },
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
        grabCursor: true,
        breakpoints: {
            300: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 25,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1440: {
                slidesPerView: 3,
             
                spaceBetween: 30,
            },
        },
    });
};
//export default initPostSwiper;

document.addEventListener('DOMContentLoaded', function () {
	initPostSwiper();
});